export const API_EXTERNAL_ENDPOINT = 'cottages/:id/conditions'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottages/conditions'
